import { Fallback } from '@cbhq/cds-web/layout/Fallback';

export function OrgSwitcherFallback() {
  return <Fallback width={200} height={40} shape="circle" />;
}
